import React from "react";
import Loading from "../../components/shared/loading/Loading";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";
import UserCard from "./UserCard";

const ManageUser = () => {
  const { users } = apiPath;
  const [userLists, userListLoading] = useFetch(users, true);
  if (userListLoading) {
    return <Loading />;
  }
  return (
    <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16">
      <div className="grid grid-cols-1 lg:grid-cols-6 gap-4">
        <UserCard />
        {userLists.map((user, index) => (
          <UserCard key={index} user={user} />
        ))}
      </div>
    </div>
  );
};

export default ManageUser;
